import Seo from "../components/Seo";
import { HowItWorks, WhyUs, CTA, SectionHeading } from "../components/sections";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const DETAIL = [
  ["Free, fast valuation", "Submit the online form or call us. We assess your car against genuine market data and give you a fair figure — no obligation, no pressure."],
  ["On-site inspection", "We come to you anywhere in Melbourne or regional Victoria (or you drop by). The inspection takes about ten minutes and confirms the offer."],
  ["Paperwork sorted", "We complete the transfer and, if your car is on finance, arrange the payout directly with your lender."],
  ["Paid on the spot", "Accept the offer and get paid immediately by cash or EFT. Prefer to think it over? Your offer stands for 7 days."],
];

export default function HowItWorksPage() {
  return (
    <>
      <Seo title="How It Works | Sell Your Car in 3 Steps | Car To Cash" description="Estimate, inspect, cash. See exactly how selling your car to Car To Cash works — free valuation, quick inspection and payment on the spot." canonical="https://cartocash.com.au/how-it-works" />
      <section className="noise-dark text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-16">
          <h1 className="font-display text-4xl sm:text-5xl font-black">How it works</h1>
          <p className="mt-3 max-w-xl text-white/75 text-lg">Three simple steps from quote to cash — most sales wrap up the same day.</p>
        </div>
      </section>
      <HowItWorks />
      <section className="mx-auto max-w-4xl px-4 sm:px-6 pb-8">
        <div className="grid gap-4 sm:grid-cols-2">
          {DETAIL.map(([t, d]) => (
            <div key={t} className="rounded-2xl border border-brand-line bg-white p-6">
              <CheckCircle2 className="h-7 w-7 text-brand-gold" />
              <h3 className="mt-3 font-display text-lg font-extrabold text-brand-navy">{t}</h3>
              <p className="mt-1 text-sm text-brand-muted leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 text-center">
          <Link to="/sell-your-car" className="inline-flex rounded-full bg-brand-gold px-8 py-4 font-extrabold text-brand-navy hover:bg-brand-goldDark transition-colors" data-testid="hiw-quote-btn">Get your free quote</Link>
        </div>
      </section>
      <WhyUs />
      <CTA />
    </>
  );
}
